import { render, staticRenderFns } from "./Preferredproducts.vue?vue&type=template&id=db533234"
import script from "./Preferredproducts.vue?vue&type=script&lang=js"
export * from "./Preferredproducts.vue?vue&type=script&lang=js"
import style0 from "./Preferredproducts.vue?vue&type=style&index=0&id=db533234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports